const state = () => ({
  location: null,
  isVisiting: null
})

const getters = {
  getIsVisiting(state) {
    return state.isVisiting
  },
  getLocation(state) {
    return state.location
  }
}

const mutations = {
  setLoaction(state, data) {
    state.location = data
  },

  setIsVisiting(state, data) {
    if (data == '' || data == null) {
      state.isVisiting = null
    } else {
      state.isVisiting = data
    }
  }
}

const actions = {
  getLocation_V2({ commit }) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          commit('setLoaction', `${position.coords.latitude},${position.coords.longitude}`)
          resolve(`${position.coords.latitude},${position.coords.longitude}`)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  getLocation({ commit }) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        commit('setLoaction', `${position.coords.latitude},${position.coords.longitude}`)
      },
      (error) => {
        console.log(error.message)
      }
    )
  },

  getCheckInOut({ commit }, { formData }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('user_id', formData.user_id)
      fommData.append('customer_id', formData.customer_id)
      fommData.append('lat_lng', formData.lat_lng)
      fetch(`${window.baseAPINew}/web/?act=check_in_out_web`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  visitCustomers({ commit }, { user_id }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('user_id', user_id)

      fetch(`${window.baseAPINew}/web/?act=visiting_customer`, { method: 'POST', body: fommData })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('setIsVisiting', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getVisitDistance({ _ }, { user_id, lat_lng }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('user_id', user_id)
      fommData.append('lat_lng', lat_lng)
      fetch(`${window.baseAPINew}/web/?act=visiting_customer_distance`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
